module.exports = __webpack_public_path__ + "static/img/img_cabinet.00a81317.png";